import PenguinIntro from './PenguinIntro';
import NameInput from './NameInput';
import PenguinIntro2 from './PenguinIntro2';

export default [PenguinIntro, NameInput, PenguinIntro2];
